import { render, staticRenderFns } from "./EntityTableList.vue?vue&type=template&id=1ffa29ae&"
import script from "./EntityTableList.vue?vue&type=script&lang=ts&"
export * from "./EntityTableList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports